import {WorkspaceClient} from "./workspace-client";
import {WorkspaceInvitation} from "./workspace-invitation";
import {BillingInfo} from "./billingInfo";
import {WorkspaceRoleForClientMapper} from "../user/workspace-roles-mapper";

export class WorkspaceMapper {

  public static workspaceClientsMap(data: any): WorkspaceClient[] {
    return data.reduce((result, client) => {
      if (client.role.id !== 1) {

        const workspaceClient: WorkspaceClient = new WorkspaceClient();

        workspaceClient.id = client.id;
        workspaceClient.name = client.name;
        workspaceClient.role = WorkspaceRoleForClientMapper.map(client.role);
        workspaceClient.email = client.email;
        workspaceClient.domains = client.domains;
        workspaceClient.status = 'client';

        result.push(workspaceClient);
      }

      return result;
    }, []);
  }

  public static workspaceInvitationsMap(data: any): WorkspaceInvitation[] {
    return data.map( invitation => {

      const workspaceInvitation: WorkspaceInvitation = new WorkspaceInvitation();

      workspaceInvitation.id = invitation.id;
      workspaceInvitation.client = invitation.client;
      workspaceInvitation.role = WorkspaceRoleForClientMapper.map(invitation.role);
      if (invitation.client) {
        workspaceInvitation.name = invitation.client.name;
      }
      workspaceInvitation.email = invitation.email;
      workspaceInvitation.domains = invitation.domains.length ? invitation.domains.map(domain => domain.domain_id) : [];

      return workspaceInvitation;
    });
  }

  public static convertToApiFormat(billingInfo: any): any {
    const data = {
      billing_first_name: billingInfo.firstName,
      billing_last_name: billingInfo.lastName,
      billing_email: billingInfo.email,
      phone_number: billingInfo.phoneNumber,
      state: billingInfo.state,
      company_name: billingInfo.companyName,
      company_vat: billingInfo.companyVat,
      address_line_1: billingInfo.companyAddressLine1,
      address_line_2: billingInfo.companyAddressLine2,
      country: billingInfo.companyCountry,
      city: billingInfo.companyCity,
      post_code: billingInfo.companyZipCode,
    };

    return data;
  }

  public static billingInfoMapper(data: any): any {
    const billingInfo: BillingInfo = new BillingInfo();

    billingInfo.firstName = data.billing_first_name;
    billingInfo.lastName = data.billing_last_name;
    billingInfo.email = data.billing_email;
    billingInfo.phoneNumber = data.phone_number;
    billingInfo.state = data.state;
    billingInfo.companyName = data.company_name;
    billingInfo.companyVat = data.company_vat;
    billingInfo.companyAddressLine1 = data.address_line_1;
    billingInfo.companyAddressLine2 = data.address_line_2;
    billingInfo.companyCountry = data.country;
    billingInfo.companyCity = data.city;
    billingInfo.companyZipCode = data.post_code;



    return billingInfo;
  }



}
